<header class="exhibitorheader">
  <bau365-breadcrumb
    [breadcrumbElements]="breadcrumbElements"
    [breadcrumbClickable]="breadcrumbClickable"></bau365-breadcrumb>
  @if (exhibitor?.mood_image?.resource) {
  <div
    class="exhibitorheader__moodimage"
    [style]="
      'background-image: url(\'' +
      (exhibitor?.mood_image?.resource | ImageUrl : exhibitor?.mood_image?.provider : {
        width: 1920,
        height: 1080,
        fileType: ImageFileTypes.WEBP,
      }) +
      '\')'
    "></div>
  } @if (!exhibitor?.mood_image?.resource) {
  <div
    class="exhibitorheader__moodimage exhibitorheader__moodimage--placeholder"
    [style]="'background-image: url(\'assets/230511_BAU-Insights_1240x310_Moodbild_V1.webp\')'">
  </div>
  }
  <div class="exhibitorheader__overlay">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <section class="pre-headline">
            <div class="exhibitorheader__summarywrapper">
              <div class="exhibitorheader__logocontainer">
                <planone-profile-picture [size]="100">
                  @if (exhibitor?.logo?.resource) {
                  <img
                    [src]="
                      exhibitor?.logo?.resource
                        | ImageUrl
                          : exhibitor?.logo?.provider
                          : { width: 100, height: 100, fileType: ImageFileTypes.WEBP }
                    "
                    [alt]="exhibitor?.name"
                    class="exhibitorheader__logo" />
                  } @else {
                  <mat-icon class="exhibitorheader__logo--placeholder">corporate_fare</mat-icon>
                  }
                </planone-profile-picture>
              </div>
              @if (fairId$ | async; as fairId) {
              <div class="exhibitorheader__summary">
                @if ((hallPlanToggle$ | async) && exhibitor?.exhibition_halls && (hallPlanActive$ | async)) { @if
                ((exhibitor?.exhibition_halls ?? []).length) {
                <planone-location
                  [exhibition_halls]="exhibitor?.exhibition_halls"
                  [fair_id]="exhibitor?.fair_id ?? fairId"
                  [locationClickable]="locationClickable"></planone-location>
                } } @if (size !== 'phone') {
                <ng-container *ngTemplateOutlet="exhibitorHeadline"></ng-container>
                }
              </div>
              }
            </div>
            <div class="topnavi__actions">
              @if (size !== 'phone') {
              <bau365-channel-subscribe-button
                class="actions__subscribe"
                [entityId]="exhibitor?.id"
                [fairId]="exhibitor?.fair_id"
                [context]="'exhibitor-details'"></bau365-channel-subscribe-button>
              }
              <button mat-icon-button class="actions__link" (click)="openShareButtonDialog($event)">
                <mat-icon class="actions__icon">share</mat-icon>
              </button>
              <bau365-toggle-watchlist-item
                entityType="EXHIBITOR"
                [entityId]="exhibitor?.id"
                [pageContext]="'exhibitor-details'"
                [fairId]="exhibitor?.fair_id"></bau365-toggle-watchlist-item>
            </div>
          </section>
          @if (size === 'phone') {
          <ng-container *ngTemplateOutlet="exhibitorHeadline"></ng-container>
          }
          <ng-template #exhibitorHeadline>
            <h1 class="exhibitor__headline mat-headline-1">{{ exhibitor?.name }}</h1>
            @if (!isBauInsights) {
            <div class="exhibitor__flags">
              @if (exhibitor?.is_main) {
              <span class="exhibitor__chip mat-caption" i18n="@@featureExhibitorDirectory-mother">
                Hauptaussteller
              </span>
              } @if (!exhibitor?.is_main) {
              <span class="exhibitor__chip mat-caption" i18n="@@featureExhibitorDirectory-child"> Mitaussteller </span>
              } @if (exhibitor?.is_startup) {
              <span class="exhibitor__chip exhibitor__chip--startup mat-caption">
                <mat-icon>rocket_launch</mat-icon>
                <ng-container i18n="@@featureExhibitors-startup-chip">Startup</ng-container>
              </span>
              }
            </div>
            } @if (size === 'phone') {
            <bau365-channel-subscribe-button
              [entityId]="exhibitor?.id"
              [fairId]="exhibitor?.fair_id"
              [context]="'exhibitor-details'"></bau365-channel-subscribe-button>
            }
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</header>
<ng-template #shareButtonsTitle>
  <span i18n="@@featureExhibitorDetails-socialShareTitle">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="socialShareUrl"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)">
  </planone-share-buttons>
</ng-template>
